<div class="sp-timer-group" [class]="classes?.element">
    <ng-container *ngIf="isExpiredTime; else notExpired">
        <div class="sp-timer-expired" [class]="classes?.wrapColumns">
            <span
                *ngIf="timerData.expiredText"
                [class]="classes?.expiredText"
                [class.mobileWidgetViewElement]="isDeviceMobile"
                [class.tabletWidgetViewElement]="isDeviceTablet"
                >{{ timerData.expiredText }}</span
            >
            <span
                *ngIf="!timerData.expiredText"
                [class]="classes?.expiredText"
                [class.mobileWidgetViewElement]="isDeviceMobile"
                [class.tabletWidgetViewElement]="isDeviceTablet"
                >{{ "timer_default_expired_text" | translate }}</span
            >
        </div>
    </ng-container>

    <ng-template #notExpired>
        <div
            [class]="classes?.wrapColumns"
            [class.mobileWidgetViewWrap]="isDeviceMobile"
            [class.tabletWidgetViewWrap]="isDeviceTablet"
        >
            <ng-container *ngIf="!isNotStartTimer; else notStartTimer">
                <div *ngIf="hasColumn('days')" class="sp-timer-item sp-timer-days" [class]="classes?.wrapColumn">
                    <div [class]="classes?.column">
                        <span
                            [class]="classes?.value"
                            [class.mobileWidgetViewElement]="isDeviceMobile"
                            [class.tabletWidgetViewElement]="isDeviceTablet"
                            >{{ remainingTime?.days }}</span
                        >
                        <span
                            [class]="classes?.label"
                            [class.mobileWidgetViewElement]="isDeviceMobile"
                            [class.tabletWidgetViewElement]="isDeviceTablet"
                            >{{ label(ETime.days) }}</span
                        >
                    </div>
                    <div class="separator" [class]="classes?.separator"></div>
                </div>
                <div *ngIf="hasColumn('hours')" class="sp-timer-item sp-timer-hours" [class]="classes?.wrapColumn">
                    <div [class]="classes?.column">
                        <span
                            [class]="classes?.value"
                            [class.mobileWidgetViewElement]="isDeviceMobile"
                            [class.tabletWidgetViewElement]="isDeviceTablet"
                            >{{ remainingTime?.hours }}</span
                        >
                        <span
                            [class]="classes?.label"
                            [class.mobileWidgetViewElement]="isDeviceMobile"
                            [class.tabletWidgetViewElement]="isDeviceTablet"
                            >{{ label(ETime.hours) }}</span
                        >
                    </div>
                    <div class="separator" [class]="classes?.separator"></div>
                </div>
                <div *ngIf="hasColumn('minutes')" class="sp-timer-item sp-timer-minutes" [class]="classes?.wrapColumn">
                    <div [class]="classes?.column">
                        <span
                            [class]="classes?.value"
                            [class.mobileWidgetViewElement]="isDeviceMobile"
                            [class.tabletWidgetViewElement]="isDeviceTablet"
                            >{{ remainingTime?.minutes }}</span
                        >
                        <span
                            [class]="classes?.label"
                            [class.mobileWidgetViewElement]="isDeviceMobile"
                            [class.tabletWidgetViewElement]="isDeviceTablet"
                            >{{ label(ETime.minutes) }}</span
                        >
                    </div>
                    <div class="separator" [class]="classes?.separator"></div>
                </div>
                <div *ngIf="hasColumn('seconds')" class="sp-timer-item sp-timer-seconds" [class]="classes?.wrapColumn">
                    <div [class]="classes?.column">
                        <span
                            [class]="classes?.value"
                            [class.mobileWidgetViewElement]="isDeviceMobile"
                            [class.tabletWidgetViewElement]="isDeviceTablet"
                            >{{ remainingTime?.seconds }}</span
                        >
                        <span
                            [class]="classes?.label"
                            [class.mobileWidgetViewElement]="isDeviceMobile"
                            [class.tabletWidgetViewElement]="isDeviceTablet"
                            >{{ label(ETime.seconds) }}</span
                        >
                    </div>
                </div>
            </ng-container>
            <ng-template #notStartTimer>
                <div *ngIf="hasColumn('days')" class="sp-timer-item sp-timer-days" [class]="classes?.wrapColumn">
                    <div [class]="classes?.column">
                        <span [class]="classes?.value">0</span>
                        <span [class]="classes?.label">{{ label(ETime.days) }}</span>
                    </div>
                    <div class="separator" [class]="classes?.separator"></div>
                </div>
                <div *ngIf="hasColumn('hours')" class="sp-timer-item sp-timer-hours" [class]="classes?.wrapColumn">
                    <div [class]="classes?.column">
                        <span [class]="classes?.value">23</span>
                        <span [class]="classes?.label">{{ label(ETime.hours) }}</span>
                    </div>
                    <div class="separator" [class]="classes?.separator"></div>
                </div>
                <div *ngIf="hasColumn('minutes')" class="sp-timer-item sp-timer-minutes" [class]="classes?.wrapColumn">
                    <div [class]="classes?.column">
                        <span [class]="classes?.value">59</span>
                        <span [class]="classes?.label">{{ label(ETime.minutes) }}</span>
                    </div>
                    <div class="separator" [class]="classes?.separator"></div>
                </div>
                <div *ngIf="hasColumn('seconds')" class="sp-timer-item sp-timer-seconds" [class]="classes?.wrapColumn">
                    <div [class]="classes?.column">
                        <span [class]="classes?.value">59</span>
                        <span [class]="classes?.label">{{ label(ETime.seconds) }}</span>
                    </div>
                </div>
            </ng-template>
        </div>
    </ng-template>
</div>
